<div class='extras-block' *ngIf='formService.questions?.length' [@slideInOut]>
	<div class='only-inner-container'>
		<div class='inner-content content-before' *ngIf='formService.questionsActive'>
			<div class='title' i18n>Recommended: Services you may also need</div>
			<form id='third-party-questions-form' class='questions-form' [formGroup]='thirdPartyForm' (ngSubmit)='onSubmit()'>
				<div class='questions-list'>
					<!-- One question per step (DEV-6874); keyed on the question so the fade runs between steps -->
					<ng-container *ngIf='formService.currentQuestion as question'>
						<app-question *ngFor='let current of [question]; trackBy: trackByKey' [@questionFadeIn] [formGroup]='thirdPartyForm' [questionIndex]='formService.currentQuestionIndex' [question]='current'></app-question>
					</ng-container>
				</div>
				<div class='form-button'>
					<button class='submit-third-party' type='submit'>
						<ng-container i18n='buttonSaveSelection'>Save</ng-container>
						<mat-icon svgIcon='icons:chevron-right'></mat-icon>
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
